



















































































































































































































































































































































































































































































































import Vue from 'vue'
import { config } from '../config'
import { headings } from '../config'
import { details } from '../details'

export default Vue.extend({
    name: 'House1',
    props: ['step1', 'step2', 'step3'],
    data: () => ({
        dialog: false,
        tile: false,
        component: 'cladding',
        headings: headings,
        parts: [
            {
                title: "The Roof Cladding",
                image: "2.png",
                text: "Wind pressures are applied to the roof cladding and forces are then transmitted through all the connections below it. Very high uplift forces are experienced at the edges of the roof.​",
                component: 'cladding',
                disabled: false,
                visible: true,
            },
            {
                title: "Batten-to-Rafter Connections",
                image: "6.png",
                text: "These hold the roof cladding securely to the rafters. These connections are often the weakest link in the hold down chain in older houses.",
                component: 'rafter',
                disabled: false,
                visible: true,

            },
            {
                title: "Ridgeline",
                image: "1.png",
                text: "The ridgeline connects the two sides of the roof together and experiences high uplift forces as wind moves over the apex of the roof​.",
                component: 'ridgeline',
                disabled: false,
                visible: true,
            },
            {
                title: "Internal Roof Connections",
                image: "7.png",
                text: "  ",
                component: 'internal',
                disabled: false,
                visible: true,

            },
            {
                title: "Roof to Wall Connections",
                image: "4.png",
                text: "These connections experience very high uplift forces as wind uplift forces try to lift the entire roof from the walls.​",
                component: 'wall',
                disabled: false,
                visible: true,

            }

        ],
        details: config
    }),
    mounted() {
        if(this.step2 == '0') {
            this.tile = true;
            this.parts[1]['disabled'] =true
        }

    }
})
